import { getEnvironmentConfig, getEnvVariable, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        editorApiServiceUrl: '',
        version: getEnvVariableDefault('APP_CORE_VERSION', 'local'),
        sentry: {
            dsn: 'https://49ff200ea11e449dbac76ce7a32312c0@o4504712601862144.ingest.sentry.io/4504791621959680',
            debug: false,
        },
        cors: {
            whitelist: getEnvVariable('APP_CORE_CORS_WHITELIST')
                ?.split(',')
                .map((s) => s.trim()) || [],
        },
        csrf: {
            enabled: getEnvVariableDefault('APP_CORE_CSRF_ENABLED', 'false') === 'true',
            secret: getEnvVariableDefault('APP_CORE_CSRF_SECRET', 'ctfcsrfsecret'),
        },
        sso: {
            providerURL: getEnvVariableDefault('APP_CORE_SSO_PROVIDER_URL', ''),
            scope: getEnvVariableDefault('APP_CORE_SSO_SCOPE', ''),
            clientID: getEnvVariableDefault('APP_CORE_SSO_CLIENT_ID', ''),
            clientSecret: getEnvVariableDefault('APP_CORE_SSO_CLIENT_SECRET', ''),
            redirectURL: getEnvVariableDefault('APP_CORE_SSO_REDIRECT_URL', ''),
            sessionLifetime: 12 * 60 * 60 * 1000, // 12 hours in milliseconds
            sessionExpiresAtMidnight: false,
        },
        redis: {
            url: getEnvVariableDefault('REDIS_URL', ''),
        },
        session: {
            resave: true,
            rolling: true,
            secret: 'cheviot-harass-publish-boil-phrasing-implode-dinah-filial-draw-ravel-torus-skate-hustle-torrent-wetland',
            saveUninitialized: false,
        },
        jwtAuthentication: {
            verificationOptions: {
                algorithms: ['HS256'],
                maxAge: '10s',
            },
        },
    },
    local: {
        redis: {
            url: 'redis://localhost:6379',
        },
        jwtAuthentication: {
            verificationOptions: {
                maxAge: '10m',
            },
        },
    },
    local_e2e: {
        redis: {
            url: 'redis://redis:6379',
        },
    },
    test: {},
    development: {},
    sandbox: {},
    staging: {},
    production: {},
};
export const editorApiServiceConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=editor-api.service.config.js.map